import { darkColors, lightColors } from '@tryhackme/thm-ui-components';
import styled from 'styled-components';

export const StyledTopBar = styled.div`
  display: flex;
  width: 100%;
  padding: 1rem 6.4rem;
  height: 5.5rem;
  background: rgba(33, 44, 66, 1);
  align-items: center;
  justify-content: flex-end;
  position: relative;
  z-index: 10;
`;

export const StyledSideSectionCloseBtn = styled.button`
  margin-left: 3rem;
  align-self: flex-start;
  position: relative;
  top: 0.4rem;
  svg {
    height: 2.8rem;
    width: 2.8rem;
    path {
      fill: ${({ theme }) => theme.colors.grey[200]};
    }
  }
`;

export const StyledAccessMachine = styled.button<{ connected?: boolean }>`
  margin-right: 1.6rem;
  padding: 1rem 1.6rem;
  color: ${({ theme }) => theme.colors.grey[100]};
  font-size: ${({ theme }) => theme.fonts.sizes.small};
  line-height: 1.6rem;
  display: flex;
  align-items: center;
  background-color: ${({ connected, theme }) => (connected ? theme.colors.primary.lighter : lightColors.error.light)};
  border-radius: 3rem;

  &::before {
    content: '';
    display: inline-block;
    width: 1.2rem;
    height: 1.2rem;
    border-radius: 50%;
    background-color: ${({ connected, theme }) => (connected ? theme.colors.primary.main : darkColors.error.main)};
    margin-right: 0.6rem;
  }

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    display: none;
  }
`;
